import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/features/tenant/not-found-client.tsx");
